import { apiFetch, API_URL, obterToken } from './apiClient';

/* Licenciamento: registros que cada empresa precisa ter em dia (backend
   /licenciamento). Gravar vai como FormData por causa do documento. */
export const listarLicenciamento = () => apiFetch('/licenciamento');
export const listarTiposRegistro = () => apiFetch('/licenciamento/tipos');
export const criarTipoRegistro = (d) => apiFetch('/licenciamento/tipos', { method: 'POST', body: JSON.stringify(d) });
export const atualizarTipoRegistro = (id, d) => apiFetch(`/licenciamento/tipos/${id}`, { method: 'PATCH', body: JSON.stringify(d) });
export const removerRegistro = (clienteId, tipoId) =>
  apiFetch(`/licenciamento/clientes/${clienteId}/registros/${tipoId}`, { method: 'DELETE' });

export async function salvarRegistro(clienteId, tipoId, dados, arquivo) {
  const form = new FormData();
  Object.entries(dados).forEach(([k, v]) => { if (v !== undefined && v !== null) form.append(k, v); });
  if (arquivo) form.append('arquivo', arquivo);
  const token = obterToken();
  const r = await fetch(`${API_URL}/licenciamento/clientes/${clienteId}/registros/${tipoId}`, {
    method: 'PUT', headers: token ? { Authorization: `Bearer ${token}` } : {}, body: form,
  });
  const json = await r.json();
  if (!r.ok) throw new Error(json.error || 'Erro ao salvar o registro');
  return json;
}

export async function baixarDocumentoRegistro(clienteId, tipoId, nome) {
  const token = obterToken();
  const r = await fetch(`${API_URL}/licenciamento/clientes/${clienteId}/registros/${tipoId}/arquivo`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!r.ok) {
    let msg = 'Erro ao baixar o documento';
    try { msg = (await r.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement('a');
  a.href = url; a.download = nome || 'documento';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const ESFERAS = {
  constituicao: 'Constituição', federal: 'Federal', estadual: 'Estadual',
  municipal: 'Municipal', conselho: 'Conselho de classe', especial: 'Especiais',
};
export const SITUACOES = {
  nao_verificado: 'Não verificado', pendente: 'Pendente', regular: 'Regular',
  irregular: 'Irregular', dispensado: 'Dispensado / não se aplica',
};

/* estado visual: regular com validade passada vira "vencido"; até 30
   dias, "vencendo" */
export function estadoRegistro(r) {
  if (!r) return 'na';
  if (r.situacao === 'regular' && r.dias_restantes != null) {
    if (r.dias_restantes < 0) return 'vencido';
    if (r.dias_restantes <= 30) return 'vencendo';
  }
  return r.situacao;
}

/* ── vários documentos por registro (contrato social, alterações...) ── */
export const listarDocumentosRegistro = (clienteId, tipoId) =>
  apiFetch(`/licenciamento/clientes/${clienteId}/registros/${tipoId}/documentos`);
export const excluirDocumentoRegistro = (id) => apiFetch(`/licenciamento/documentos/${id}`, { method: 'DELETE' });

/* alteracao=true na Constituição reinicia o licenciamento do cliente;
   devolve { reiniciados } = quantos registros voltaram pra pendente */
export async function enviarDocumentoRegistro(clienteId, tipoId, { descricao, data, alteracao }, arquivo) {
  const form = new FormData();
  form.append('descricao', descricao);
  if (data) form.append('data', data);
  form.append('alteracao', alteracao ? 'true' : 'false');
  form.append('arquivo', arquivo);
  const token = obterToken();
  const r = await fetch(`${API_URL}/licenciamento/clientes/${clienteId}/registros/${tipoId}/documentos`, {
    method: 'POST', headers: token ? { Authorization: `Bearer ${token}` } : {}, body: form,
  });
  const json = await r.json();
  if (!r.ok) throw new Error(json.error || 'Erro ao enviar o documento');
  return json;
}

export async function baixarDocumentoAvulso(id, nome) {
  const token = obterToken();
  const r = await fetch(`${API_URL}/licenciamento/documentos/${id}/arquivo`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!r.ok) throw new Error('Erro ao baixar o documento');
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement('a');
  a.href = url; a.download = nome || 'documento';
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/* registro que voltou pra pendente por alteração contratual e ainda não
   foi revisado depois disso */
export const aguardandoRevisao = (r) =>
  !!r?.reiniciado_em && (!r.verificado_em || new Date(r.verificado_em) < new Date(r.reiniciado_em));
